import ApiError, { ApiErrorType } from './ApiError';

export default function handleUnauthorizedRequest() {
    // We throw ApiError which is caught by UnhandledExceptionErrorBoundary or ErrorPage, which is further processed
    // and uses React Router's navigation to redirect to the login.
    throw new ApiError(ApiErrorType.UNAUTHORIZED);
}
